import { Directive, ElementRef, Renderer2, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject } from 'rxjs';
import { DfHeaderUi } from '../df-header-ui.interfaces';
import { DfHeaderUiService } from '../service/df-header-ui.service';

interface IGenerator<T> {
    state$: BehaviorSubject<T>;
    getClass: (value: T) => string;
}

@Directive({
    selector: '[dfHeaderUiHeader]',
    standalone: true
})
export class DfHeaderUiHeaderDirective {
    /**
     * Header service
     */
    private dfHeaderUiService = inject(DfHeaderUiService);

    /**
     * Renderer service
     */
    private renderer2 = inject(Renderer2);

    /**
     * Element reference
     */
    private elementRef = inject(ElementRef);

    /**
     * Module config
     */
    private moduleConfig = inject(DfHeaderUi.OPTIONS);

    /**
     * Subscription setup
     */
    constructor() {
        const generators: IGenerator<any>[] = [
            {
                getClass: (value: boolean) => (value ? this.moduleConfig.fields.transparency.className : ''),
                state$: this.dfHeaderUiService.isTransparent$
            } as IGenerator<boolean>,
            {
                getClass: (value: string) => (value && this.moduleConfig.fields.theme.options[value] ? value : ''),
                state$: this.dfHeaderUiService.theme$
            } as IGenerator<string>
        ];

        generators.forEach(({ getClass, state$ }) => {
            let addedClass: string;
            state$.pipe(takeUntilDestroyed()).subscribe(state => {
                const className = getClass(state);
                if (addedClass === className) {
                    return;
                }
                if (addedClass) {
                    this.renderer2.removeClass(this.elementRef.nativeElement, addedClass);
                }
                if (className) {
                    this.renderer2.addClass(this.elementRef.nativeElement, className);
                }
                addedClass = className;
            });
        });
    }
}
